import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";

/**
 * Client-side auth gate. Ο έλεγχος γίνεται μέσα στο component (και όχι με
 * `redirect` στο `beforeLoad`) ώστε ο client να μην αλλάζει route την ώρα του
 * hydration — αυτό προκαλούσε "Hydration failed" στη σελίδα λογαριασμού.
 */
function AuthGate() {
  const navigate = useNavigate();
  const [status, setStatus] = useState<"checking" | "ok">("checking");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      // Lazy import: κρατά το supabase chunk εκτός του main bundle.
      const { supabase } = await import("@/integrations/supabase/client");
      const { data, error } = await supabase.auth.getUser();
      if (cancelled) return;
      if (error || !data.user) {
        navigate({ to: "/login", replace: true });
        return;
      }
      setStatus("ok");
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);


  if (status === "checking") {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-muted border-t-primary" />
      </div>
    );
  }
  return <Outlet />;
}

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  component: AuthGate,
});
